module.exports = __webpack_public_path__ + "static/img/software34.c9a738ec.png";